/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_015: Question = {
  id: 'pres-015-zones-noyaux-sad-pmad',
  oldId: '29',
  title: 'Intégration des zones noyaux ou des milieux naturels d’intérêt et du concept de corridor de connectivité dans le schéma d’aménagement et de développement (SAD) ou Plan métropolitain d’aménagement et de développement (PMAD)',
  number: '2.15',
  description: [''],
  type: QuestionType.ACTIVITY,
  frequency: 1,
  idEM: 3,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: true,
      score: '0',
      scoringFct: (data: string[]) => parseFloat(data[0]),
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};
const question_pres_015__v3: Question = {
  ...question_pres_015,
  number: '2.13',
};

export const question_pres_015_v2: Question = question_pres_015;
export const question_pres_015_v3: Question = question_pres_015__v3;
